// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Panel/Panel.css
// module id = 1601
// module chunks = 193